import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {RincianPertanggunganBsiComponent} from "./rincian-pertanggungan-bsi.component";
import {LayoutComponent} from "../../layout/layout.component";

const routes: Routes = [
  {
    path: 'rincian-pertanggungan-bsi',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: RincianPertanggunganBsiComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RincianPertanggunganBsiRoutingModule { }
